import { setFocusedMediaElementUuidAction as setFocusedMediaElementUuidOperation } from 'editor/src/store/editor/slice';

export default setFocusedMediaElementUuidOperation;
